import React, { useCallback, useMemo, useState } from "react";
import { FaArrowRight, FaSearch, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // Import useNavigate

import { useManagers } from "../../hooks/queries";

import HeaderContainer from "../CrewDashboard/HeaderContainer";
import Driver from "../../images/Male.png";

const driversPerPage = 15; // 3 rows of 5 cards each
const ManagerDetail = () => {
  const navigate = useNavigate(); // Use useNavigate instead of useHistory

  const { data: managersData, isSuccess: successManagers } = useManagers();

  const drivers = useMemo(() => {
    const list =
      managersData?.map((_item, index) => ({
        id: index,
        UserID: _item.UserID,
        name: (() => {
          const mgr = Array.isArray(_item.Managers) ? _item.Managers[0] : _item.Managers;
          if (mgr?.firstname || mgr?.lastname) {
            return `${mgr.firstname || ""} ${mgr.lastname || ""}`.trim();
          }
          // Derive name from email: "first.last@..." -> "First Last"
          const local = (_item.Email || "").split("@")[0] || "";
          const parts = local.split(".");
          return parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(" ") || `Manager ${index + 1}`;
        })(),
        experience: _item.Email,
        airports: Array.isArray(_item.Locations) ? _item.Locations.map((l) => l.Code || l.Description).filter(Boolean) : [],
        hasLocations: Array.isArray(_item.Locations) && _item.Locations.length > 0,
      })) ?? [];
    list.sort((a, b) => (b.hasLocations ? 1 : 0) - (a.hasLocations ? 1 : 0));
    return list;
  }, [managersData]);

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useMemo(
    () => Math.ceil(drivers.length / driversPerPage),
    [drivers]
  );
  const currentDrivers = useMemo(
    () =>
      drivers.slice(
        (currentPage - 1) * driversPerPage,
        currentPage * driversPerPage
      ),
    [currentPage, drivers]
  );

  // Pagination Logic
  const addNew = useCallback(() => {
    navigate("/manager-new");
  }, [navigate]);

  const onDetail = useCallback(
    (driver) => () => {
      navigate(`/manager-info/${driver.UserID}`);
    },
    [navigate]
  );

  return (
    <div className="p-6 w-full">
      <HeaderContainer />
      {/* Top Section */}
      <div className="flex w-full items-center mt-4 mid-wrap-bar">
        <p className="font-semibold text-lg">All Managers [{drivers.length}]</p>

        <div className="flex-1 flex justify-end items-center space-x-4">
          {/* Search Input */}
          <div className="search-input-wrapper">
            <div className="search-input-container">
              <input
                type="text"
                placeholder="Search Flight..."
                className="search-input"
              />
              <FaSearch className="search-icon" />
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <div
            onClick={addNew}
            className="justify-between p-2 pr-20 pl-20 rounded-lg flex items-center custom-button m-2"
          >
            <span>Add New</span>
          </div>

          {/* Dropdown */}
          <select className="custom-input border border-gray-300 rounded-lg py-2 px-4 focus:outline-none ml-1">
            <option>All Manager</option>
          </select>
        </div>
      </div>

      {/* Driver Info Grid */}

      {/* Pagination Controls */}
      <div>
        {/* Driver Cards Grid */}
        <div className="driver-grid">
          {currentDrivers.map((driver) => (
            <div>
              <div key={driver.id} className="driver-card">
                <div>
                  <img src={Driver} alt="Driver" className="driver-img" />
                  <h2 className="driver-name">{driver.name}</h2>
                  <p className="driver-experience">{driver.experience}</p>
                  {driver.airports.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1 justify-center" style={{ marginBottom: 8 }}>
                      {driver.airports.map((code) => (
                        <span key={code} className="airport-badge">
                          {code}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* More Info Button */}
                <div
                  onClick={onDetail(driver)}
                  className="more-info-button cursor-point"
                >
                  <span>More Info</span>
                  <FaArrowRight />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="pagination-container">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="pagination-button"
          >
            <FaArrowLeft className="pagination-icon" />
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => setCurrentPage(i + 1)}
              className={`pagination-button ${currentPage === i + 1 ? "active" : ""
                }`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() =>
              setCurrentPage((prev) =>
                Math.min(prev + 1, Math.ceil(drivers.length / driversPerPage))
              )
            }
            disabled={currentPage * driversPerPage >= drivers.length}
            className="pagination-button"
          >
            <FaArrowRight className="pagination-icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManagerDetail;
